import type { InventoryFormSchema } from '@/_pages/settings/inventory-kits/shared/schemas/inventory';
import type {
  VendorDetailsFormSchema,
  VendorDetailsUpdateSchema,
} from '@/_pages/settings/inventory-kits/shared/schemas/vendor-details';
import { currencyInput } from '@/_schemas/generic';

export function vendorDetailsFormToUpdate(
  vendor_details: VendorDetailsFormSchema[],
  vendors: InventoryFormSchema['vendors']
): number[] {
  const inventoryVendors = vendors?.map(({ id }) => id) ?? [];
  return vendor_details.map(({ vendor_id }) => vendor_id).filter((id) => !inventoryVendors.includes(id));
}

export function vendorDetailsFormToUpdateSingle(vd: VendorDetailsFormSchema): VendorDetailsUpdateSchema {
  return {
    ...vd,
    last_price: currencyInput.formToUpdateConverter(vd.last_price),
  };
}
